export const blockIconsPhotoandimageAspectRatioNew = (
	<span className='material-symbols-outlined'>aspect_ratio</span>
);
